import React from "react";
import "../../css/progressbar.css";

const ProgressBar = ({ percentage, barHeight = 6 }) => {
  // Show percent text inside the blue bar if percentage > 0, otherwise center it in the background
  return (
    <div
      className="progress-bar-container"
      style={{ width: "100%", minWidth: 0, position: "relative" }}
    >
      <div
        className="progress-bar-bg"
        style={{
          background: "#e0e0e0",
          borderRadius: 8,
          height: barHeight,
          width: "100%",
          position: "relative",
        }}
      >
        <div
          className="progress-bar-fill"
          style={{
            width: `${percentage}%`,
            background: "linear-gradient(90deg, #6bb6f9 0%, #4a90e2 100%)",
            height: barHeight,
            borderRadius: 8,
            transition: "width 0.4s",
            minWidth: 0,
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          {percentage > 0 && (
            <span
              className="progress-bar-percentage"
              style={{
                color: "#fff",
                fontWeight: 500,
                fontSize: 11,
                whiteSpace: "nowrap",
                pointerEvents: "none",
                zIndex: 2,
                textAlign: "center",
                width: "100%",
                position: "absolute",
                left: 0,
                top: "50%",
                transform: "translateY(-50%)",
              }}
            >
              {percentage}%
            </span>
          )}
        </div>
        {percentage === 0 && (
          <span
            className="progress-bar-percentage"
            style={{
              color: "black",
              fontWeight: 500,
              fontSize: 13,
              whiteSpace: "nowrap",
              pointerEvents: "none",
              zIndex: 2,
              textAlign: "center",
              width: "100%",
              position: "absolute",
              left: 0,
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            0%
          </span>
        )}
      </div>
    </div>
  );
};

export default ProgressBar;
